import { render, staticRenderFns } from "./ShopContacts.vue?vue&type=template&id=2b12d755&"
import script from "./ShopContacts.vue?vue&type=script&lang=js&"
export * from "./ShopContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports